import React from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'
import SystemMessageLayout from 'components/wrapper/SystemMessageLayout'

const { dark, fontWeight } = sys

const Title = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.systemMessage.title
})`
  font-family: var(--large-font-family);
  font-weight: ${fontWeight.regular};
  font-size: 36px;
  line-height: 42px;
  margin-bottom: 20px;
`

const Content = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.systemMessage.content
})`
  font-family: var(--large-font-family);
  line-height: ${sys.typescale[16].lineHeight};
  font-size: ${sys.typescale[16].size};
`

const Footer = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.systemMessage.footer
})`
  color: ${dark.text.weak};
  margin-top: 120px;
  line-height: ${sys.typescale[12].lineHeight};
  font-size: ${sys.typescale[12].size};
`

const SystemMessageLiveReport = () => {
  const location = useLocation()
  const { errorCode = 'liveReportStatusCode.unspecific', ...messageParams } = location.state ?? {}
  const { t } = useTranslation()

  return (
    <SystemMessageLayout>
      <Title>{t(`${errorCode}.title`)}</Title>
      <Content>{t(`${errorCode}.message`, messageParams)}</Content>
      <Footer>{t('quidCopyright', { year: new Date().getFullYear() })}</Footer>
    </SystemMessageLayout>
  )
}

export default SystemMessageLiveReport
